import { render, staticRenderFns } from "./CollectionImageShowScreen.vue?vue&type=template&id=3edcc12a&"
import script from "./CollectionImageShowScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionImageShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports